import { render, staticRenderFns } from "./CredenciamentoFornecedorDocumentos.vue?vue&type=template&id=4fae773a"
import script from "./CredenciamentoFornecedorDocumentos.vue?vue&type=script&lang=js"
export * from "./CredenciamentoFornecedorDocumentos.vue?vue&type=script&lang=js"
import style0 from "./CredenciamentoFornecedorDocumentos.vue?vue&type=style&index=0&id=4fae773a&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports